/* eslint-disable object-shorthand */
import { useState } from 'react';
import { TextWrap as Text, View, TextInput, styles as sc, HelperText, SplitBox } from '../../../components/Themed';
import { RootStackScreenProps } from '../../../navigation/navigationTypes';
import SnapCalorieSitePage from '../../../components/SnapCalorieSitePage';
import TextButton from '../../../components/elements/TextButton';
import apiConst from '../../../constants/Api';
import { ApiSuccessResponse } from '../../../types/AppTypes';

export default function CreateReferralAccount({ navigation, route }: RootStackScreenProps<'Refer'>) {
  const referralId = route.params ? route.params.id ?? route.params.id : 'No Referral Id';

  console.log(referralId);
  // From checkout flow
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');

  // Page components
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');

  const [showFormErrors, setShowFormErrors] = useState(false);
  const [formErrorMessage, setFormErrorMessage] = useState('');

  const onChangePassword = (newText: string) => setPassword(newText);
  const onChangePasswordConfirm = (newText: string) => setPasswordConfirm(newText);
  const onChangeName = (newText: string) => setName(newText);
  const onChangeEmail = (newText: string) => setEmail(newText);

  const hasPasswordErrors = () => {
    return password.length < 8;
  };

  const hasPasswordConfirmErrors = () => {
    return password !== passwordConfirm;
  };

  const hasNameErrors = () => {
    return !name || name.length < 1;
  };

  const hasEmailErrors = () => {
    return !email || email.length < 1 || !email.includes('@');
  };

  const handleSubmit = () => {
    if (hasNameErrors() || hasPasswordErrors() || hasPasswordConfirmErrors()) {
      setShowFormErrors(true);
    } else {
      const backendUrl = `${apiConst.backendUrl}/auth/cognito/register`;
      const registerBody = {
        name: name,
        email: email,
        password: password,
        attributes: JSON.stringify({ referredBy: referralId, referredOn: new Date().toISOString() }),
      };
      fetch(backendUrl, {
        method: 'POST',
        body: new URLSearchParams(registerBody),
      })
        .then((resp) => {
          resp.json().then((jsonResp) => {
            if (resp.status === 201) {
              navigation.navigate('ReferralVerification', { email: email });
            } else {
              console.error(`An error occurred during registration: ${(jsonResp as ApiSuccessResponse).message}`);
              setFormErrorMessage((jsonResp as ApiSuccessResponse).message!);
            }
          });
        })
        .catch((err) => {
          setFormErrorMessage(err);
        });
    }
  };

  console.log(referralId);
  return (
    <SnapCalorieSitePage
      headerLinks={{
        Home: () => {
          navigation.navigate('Home');
        },
      }}
    >
      <SplitBox
        flex={[1]}
        mobileView={false}
        style={{
          alignSelf: 'center',
        }}
        key="SplitBox"
      >
        <View style={{ maxWidth: 350 }} key="ContainerView">
          <Text style={[sc.focusText, { fontSize: 20, textAlign: 'center' }]}>
            You have been given 14 days of SnapCalorie Pro, free.{'\n\n'}Create your account to sign in.
          </Text>
          <TextInput placeholder="Name" value={name} onChangeText={onChangeName} />
          <HelperText style={showFormErrors ? sc.invalidText : sc.hintText} visible={hasNameErrors()}>
            Please enter your name.
          </HelperText>
          <TextInput placeholder="Email" value={email} onChangeText={onChangeEmail} />
          <HelperText style={showFormErrors ? sc.invalidText : sc.hintText} visible={hasEmailErrors()}>
            Please enter your email.
          </HelperText>
          <View>
            <TextInput placeholder="Password" value={password} onChangeText={onChangePassword} secureTextEntry />
            {/* <PasswordStrengthBar password={password} minLength={8} /> */}
            <HelperText style={showFormErrors ? sc.invalidText : sc.hintText} visible={hasPasswordErrors()}>
              Password must be at least 8 characters.
            </HelperText>
          </View>
          <View>
            <TextInput
              placeholder="Confirm Password"
              value={passwordConfirm}
              onChangeText={onChangePasswordConfirm}
              secureTextEntry
            />
            <HelperText style={showFormErrors ? sc.invalidText : sc.hintText} visible={hasPasswordConfirmErrors()}>
              Password confirmation does not match.
            </HelperText>
          </View>
          <TextButton
            onPress={() => {
              handleSubmit();
            }}
            text="Create My Account"
            textStyle={sc.buttonText}
            style={[sc.buttonWrapper, { backgroundColor: '#2364AA' }]}
          />
          <HelperText style={sc.invalidText} visible={formErrorMessage.length > 0}>
            {formErrorMessage}
          </HelperText>
        </View>
      </SplitBox>
    </SnapCalorieSitePage>
  );
}
